import React, {PureComponent, ChangeEvent} from 'react'
import {t} from 'helpers/i18n'
import {Select} from 'elements'

interface Props<T> {
  selectedFilter: number
  filters: {
    name: string
    filter(item: T): boolean
  }[]
  onSelect(value: number): void
}

class Filter<T> extends PureComponent<Props<T>, object> {
  handleSelect = (event: ChangeEvent<HTMLSelectElement>) => {
    this.props.onSelect(Number(event.target.value))
  }

  render() {
    const {filters, selectedFilter, onSelect, ...props} = this.props
    return (
      <Select
        {...props}
        onChange={this.handleSelect}
        value={'0'}
        underline={false}
        options={filters.map((filter, index) => ({
          name: t(filter.name),
          value: index
        }))}
      />
    )
  }
}

export default Filter



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Filter.tsx